import { render, staticRenderFns } from "./ManualAPIRefresh.vue?vue&type=template&id=462b951c&scoped=true"
import script from "./ManualAPIRefresh.vue?vue&type=script&lang=ts"
export * from "./ManualAPIRefresh.vue?vue&type=script&lang=ts"
import style0 from "./ManualAPIRefresh.vue?vue&type=style&index=0&id=462b951c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b951c",
  null
  
)

export default component.exports